module.exports = __webpack_public_path__ + "assets/416565075a1db2211aa52fa66013c766.png";